import React from "react";
import PropTypes from "prop-types";
import { Box, Icon, Loading, Small } from "orcs-design-system";
import { StyledToolCallBubble } from "../StyledComponents";

/**
 * Compact tool-usage badge for v3 chat.
 * Shows a count of tools used with a spinner or check icon.
 */
export const ToolBadge = ({ message, allToolsCalled = [] }) => {
  const isRunning = message.status === "pending";

  return (
    <StyledToolCallBubble>
      <Box mr="s">
        {isRunning ? (
          <Loading small mr="s" />
        ) : (
          <Icon icon={["fas", "check-circle"]} />
        )}
      </Box>
      <Small color="mutedText">
        {`${allToolsCalled.length} ${allToolsCalled.length > 1 ? "tools" : "tool"} used`}
      </Small>
    </StyledToolCallBubble>
  );
};

ToolBadge.propTypes = {
  message: PropTypes.shape({
    status: PropTypes.string,
  }),
  allToolsCalled: PropTypes.array,
};
